module.exports = __webpack_public_path__ + "img/k3-1.f215961b.png";